module.exports = "/packs/coaching-guide-image-9b1ce6346eeb449daa41a403675446a0.png";